// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_pages_dashboard_dashboard_module_ts":"7c876ee2b9dca0c7","src_app_pages_queue_queue_module_ts":"59f031e64750cbcb","src_app__core_services_heartbeat_worker_ts":"fdbb934ed1f3d2a5"}[chunkId] + ".js";
};